import { Modal } from "react-bootstrap";
import BftButton from "../button";

const ConfirmationModal = ({
	show,
	onClose,
	onCloseCellulare,
	title,
	message,
	onConfirm,
	yesLabel = "Sì",
	noLabel = "No",
	disableCloseButton = false,
}: {
	show: boolean;
	onClose: any;
	onCloseCellulare?: any;
	title: any;
	message: any;
	onConfirm: any;
	yesLabel?: string;
	noLabel?: string;
	disableCloseButton?: boolean;
}) => {
	return (
		<>
			<Modal show={show} backdrop="static" onHide={onClose} keyboard={false}>
				<Modal.Header
					closeButton={!disableCloseButton}
					className={disableCloseButton ? "text-center justify-content-center" : ""}
				>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body className={disableCloseButton ? "" : ""}>{message}</Modal.Body>
				<Modal.Footer className="justify-content-center">
					<BftButton className="btn-buffetti-secondary" onClick={onCloseCellulare || onClose}>
						{noLabel}
					</BftButton>
					<BftButton className="btn-buffetti ml-auto" onClick={onConfirm}>
						{yesLabel}
					</BftButton>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default ConfirmationModal;
